import { Button, ErrorSummary, Hidden } from '@ahmdigital/ui';
import { connect } from 'react-redux';
import { Form, useFormikContext } from 'formik';
import { isEmpty } from 'lodash/fp';
import React, { useEffect, useState } from 'react';

import { Location } from '../../../../types/location';
import { Match } from '../../types';
import { ProductType } from '../../../../types/product';
import AgeField from './components/age-field';
import ExcessToggle from './components/excess-toggle';
import IncomeTierField from './components/income-tier-field';
import IncomeTypeField from './components/income-type-field';
import PaymentFrequencyField from './components/payment-frequency-field';
import ScaleField from './components/scale-field';
import selectExcessToggleValues, { ExcessToggleValues } from '../../../../selectors/select-excess-toggle-values';
import selectIsExcessToggleApplicable, {
  IsExcessToggleApplicableType,
} from '../../../../selectors/select-is-excess-toggle-applicable';
import StateField from './components/state-field';

const schemaForErrorSummary = {
  age: {
    linkPhrases: ['age'],
  },
  partnerAge: {
    linkPhrases: ['partner’s age'],
  },
};

type CustomerFormProps = {
  hasSubmitAttempt?: boolean;
  hospitalExcess: ExcessToggleValues;
  isExcessApplicable: IsExcessToggleApplicableType;
  isProductWithHospitalServices: boolean;
  location?: Location;
  match?: Match;
  product?: ProductType;
  showIncomeOptions?: boolean;
};

const CustomerForm = ({
  hasSubmitAttempt,
  hospitalExcess,
  isExcessApplicable,
  isProductWithHospitalServices,
  location,
  match,
  product,
  showIncomeOptions,
}: CustomerFormProps) => {
  const { errors, handleSubmit, isSubmitting, touched } = useFormikContext();
  const [showErrorSummary, setShowErrorSummary] = useState(false);

  useEffect(() => {
    if (isSubmitting && !isEmpty(errors)) {
      setShowErrorSummary(true);
    }
  }, [errors, isSubmitting]);

  return (
    <>
      {showErrorSummary && <ErrorSummary errors={errors} schema={schemaForErrorSummary} touched={touched} />}
      <Form onSubmit={handleSubmit}>
        <ScaleField product={product} />
        <StateField />
        {/* @ts-expect-error - Automatic, Please fix when editing this file */}
        <PaymentFrequencyField location={location} />
        {/* @ts-expect-error - Automatic, Please fix when editing this file */}
        <AgeField hasSubmitAttempt={hasSubmitAttempt} isProductWithHospitalServices={isProductWithHospitalServices} />
        <ExcessToggle hospitalExcess={hospitalExcess} isExcessApplicable={isExcessApplicable} match={match} />
        {showIncomeOptions && <IncomeTypeField />}
        {showIncomeOptions && <IncomeTierField />}
        {/* Hidden button to allow Enter key to submit form */}
        <Hidden md sm xs df lg>
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: string; type: string; onClick: (e?: FormEvent<HTMLFormElement> | undefined) => void; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<ButtonProps, keyof ButtonProps> & Pick<InferProps<{ variant: Requireable<NonNullable<string | object | null | undefined>>; analytics: Requireable<...>; }>, "analytics"> & Pick<...>, "icon" | "analytics"> & Partial<...> & Partial<...>'. */}
          <Button type="submit" onClick={handleSubmit}>
            Update
          </Button>
        </Hidden>
      </Form>
    </>
  );
};

CustomerForm.defaultProps = {
  location: null,
  match: null,
  product: {},
  showIncomeOptions: true,
};

// @ts-expect-error - Automatic, Please fix when editing this file
const mapStateToProps = (state, props) => ({
  hospitalExcess: selectExcessToggleValues(state),
  isExcessApplicable: selectIsExcessToggleApplicable(state, props),
  location: state?.router?.location,
  products: state.product.data,
});

export default connect(mapStateToProps)(CustomerForm);
